import { useEffect, useRef } from 'react';
import { useDashboardSettings } from '../../../hooks/useDashboardSettings';
import { quotesWebSocketService } from '../QuotesWebSocketService';
import { spreadsWebSocketService } from '../SpreadsWebSocketService';
import Config from '../../../config';

/**
 * useFeedWorkerIntervalSync
 * 
 * This hook syncs the feedSyncIntervalMs setting from dashboard settings
 * to the quotes and spreads workers. When the user changes the "Quote update interval"
 * in dashboard settings, this hook updates the workers' flush intervals.
 * 
 * Only performs updates when Config.perf.batchedQuotes is enabled (when workers are used).
 */
export const useFeedWorkerIntervalSync = (): void => {
  const { feedSyncIntervalMs } = useDashboardSettings();
  const prevIntervalRef = useRef<number | undefined>(undefined);

  useEffect(() => {
    // Only run when workers are enabled
    if (!(Config.perf && Config.perf.batchedQuotes)) {
      return;
    }

    // Only update if the interval has actually changed
    if (feedSyncIntervalMs !== prevIntervalRef.current) {
      if (typeof feedSyncIntervalMs === 'number' && feedSyncIntervalMs > 0) {
        quotesWebSocketService.updateWorkerInterval(feedSyncIntervalMs);
        spreadsWebSocketService.updateWorkerInterval(feedSyncIntervalMs);
      }
      prevIntervalRef.current = feedSyncIntervalMs;
    }
  }, [feedSyncIntervalMs]);
};
